<template>
	<div class="wh100" style="height:calc(100% - 50px);">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane v-for="item in stationList" 
				:label="item.stationname" 
				:name="item.id">
				<el-descriptions :column="2" border size="small">
					<el-descriptions-item>
					      <template slot="label">
					        监测点名称:	
					      </template>
					      {{item.stationname}}
					</el-descriptions-item>
					<el-descriptions-item>
					      <template slot="label">
					        监测点编号:	
					      </template>
					      {{item.stationcode}}
					</el-descriptions-item>
					<el-descriptions-item>
					      <template slot="label">
					        施工许可证编号:
					      </template>
					      {{buildingData.constructionNum}}
					</el-descriptions-item>
					<el-descriptions-item>
					      <template slot="label">
					        设备品牌:	
					      </template>
					      {{item.StationName}}
					</el-descriptions-item>
					<el-descriptions-item>
					      <template slot="label">
					        设备型号:
					      </template>
					      {{item.StationName}}
					</el-descriptions-item>
					<el-descriptions-item>
					      <template slot="label">
					        检测方法:
					      </template>
					      {{item.StationName}}
					</el-descriptions-item>
				</el-descriptions>
			</el-tab-pane>
		</el-tabs>
		<MyPannel>
		  <el-row :gutter="20">
			  <el-col :span="4">
				  <el-date-picker
				    v-model="params.timeStart"
				    type="datetime"
						format="yyyy-MM-dd HH"
						value-format="yyyy-MM-dd HH:00:00"
						:picker-options="pickerOptions0">
				  </el-date-picker>
			  </el-col>
			  <el-col :span="4">
				  <el-date-picker
						v-model="params.timeEnd"
						type="datetime"
						format="yyyy-MM-dd HH"
						value-format="yyyy-MM-dd HH:00:00"
						:picker-options="pickerOptions0">
				  </el-date-picker>
			  </el-col>
			  <el-col :span="2">
				  <el-button type="primary" @click="query">查询</el-button>
			  </el-col>
		  </el-row>
		  <my-table
		    ref="mytable"
		    id="mytable"
		    :url="table.url"
		    :method="table.method"
		    :params="params"
		    index-column
		    custom-sort
		    stripe
		    fit
		    border
		    style="width: 100%;margin-top: 10px;height: 45vh;"
			  :autoLoad="false"
		  >
			<template slot="columns">
				<el-table-column
				  prop="collecttime"
				  label="数据时间"
				  align="center"
				  min-width="100"
				>
				</el-table-column>
				<el-table-column
				  prop="pm25V"
				  label="PM2.5"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="pm10V"
				  label="PM10"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="tpV"
				  label="大气温度"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="tdV"
				  label="大气湿度"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="wdname"
				  label="风向"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="wsV"
				  label="风速"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
				<el-table-column
				  prop="wpV"
				  label="大气压"
				  align="center"
				  min-width="100"
				  sortable
				>
				</el-table-column>
			</template>
		  </my-table>
		</MyPannel>
	</div>
</template>

<script>
import MyPannel from "@/components/Pannel/Pannel";
import MyTable from "@/components/PageTable";
export default {
  components: {
    MyPannel,
    MyTable,
  },
  props: ["buildingInfo"],
  data() {
    return {
		activeName:"",
		params:{
			timeStart: this.$util.formatDate24(new Date(new Date().getTime()-24*60*60*1000),"yyyy-MM-dd HH:00:00"),
			timeEnd:this.$util.formatDate24(new Date(),"yyyy-MM-dd HH:00:00"),
			stationId:"",
		},
		table:{
			url:"/baseStation/getStationHisData",
			method:"POST",
		},
		stationList:[],
		buildingData:this.buildingInfo,
		pickerOptions0:{
			disabledDate(time) {
				let curDate = (new Date()).getTime();
				let three = 30 * 24 * 3600 * 1000;
				let threeMonths = curDate - three;
				return time.getTime() > Date.now() || time.getTime() < threeMonths;
			}
		},
	};
  },
  created() {
  	this.getStationList();
  },
  mounted() {
  	
  },
  methods: {
	  handleClick(tab, event){
		  this.params.stationId = this.activeName;
		  this.query();
	  },
	  getStationList(){
		  let _this =this;
		  _this.$api.post(
			"/baseStation/getStationListBySiteId",
			{buildingSiteId:_this.buildingInfo.id},
			function(res){
				if(res.code=="0000"){
					_this.stationList = res.data;
					_this.activeName = _this.stationList[0].id;
					_this.params.stationId = _this.stationList[0].id;
					_this.query();
				}
			}
		  )
	  },
	  query() {
	    this.$refs.mytable.reload();
	  },
  },
}
</script>

<style  scoped lang="less">
.el-tabs.el-tabs--top{
	height: 100% !important;
}
.el-tabs__content{
	height: calc(100% - 45px) !important;
}
.content-container{
	height:calc(100% - 0px) !important;
}
</style>